// extracted by mini-css-extract-plugin
export default {"container":"styles_container__HP8Z5","bleed":"styles_bleed__X9S5s"};